/**
 * Application version configuration
 * Version is injected at build time from package.json
 */

/**
 * Detect if running in development mode
 */
export const IS_DEVELOPMENT = process.env.NODE_ENV === 'development';

/**
 * Get the application version from environment variables
 * In development mode, shows 'dev' label
 * In production, shows the actual version from package.json
 */
export const APP_VERSION = process.env.REACT_APP_VERSION || 'unknown';

/**
 * Get the build timestamp if available (only in production builds)
 */
export const BUILD_TIMESTAMP = process.env.REACT_APP_BUILD_TIMESTAMP || '';

/**
 * Get the git commit hash if available (only in production builds)
 */
export const GIT_COMMIT = process.env.REACT_APP_GIT_COMMIT || '';

/**
 * Format version information for display
 * Shows "v1.0.0-dev" in development mode, "v1.0.0" in production
 * Appends git commit short hash if available
 */
export const getVersionInfo = (): string => {
    return `v${APP_VERSION}` + (IS_DEVELOPMENT ? '-dev' : '') + (GIT_COMMIT ? ` (${GIT_COMMIT.substring(0, 7)})` : '');
};

/**
 * Log version information to console for debugging
 */
export const logVersionInfo = (): void => {
    console.info('='.repeat(50));
    console.info('𓅞 Djehooty Frontend');
    console.info(`Mode: ${IS_DEVELOPMENT ? 'dev' : 'prod'}`);
    console.info(`Version: ${APP_VERSION}`);
    if (BUILD_TIMESTAMP) {
        const buildDate = new Date(BUILD_TIMESTAMP);
        console.info(`Build: ${buildDate.toISOString().replace('T', ' ').substring(0, 19)} UTC`);
    }
    if (GIT_COMMIT) {
        console.info(`Commit: ${GIT_COMMIT}`);
    }
    console.info('='.repeat(50));
};